export default function CMacros() {
  return <h2>C Macros</h2>;
}
